import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { Checkbox } from './Checkbox';
import { xor as _xor } from 'lodash';
import { IBoxCheckboxListComponent, IBoxComponent } from '@enuan/chat__utils';
import { cleanBoxProps } from '../../../utils/cleanBoxProps';
import { useDidUpdateEffect } from '@avalenti89/react-ts-utils';
import { FormRow, IFormRowProps } from './FormRow';

type Props = IBoxComponent<IBoxCheckboxListComponent> &
	IFormRowProps & {
		onChange?: (value: string[]) => string[];
	};

export const CheckboxList = ({
	// custom props
	type,
	help_label,
	error,
	error_label,
	required_label,
	label,
	onChange,

	// standard props
	id, //ignore it to avoid duplicate
	options,
	value,
	className,
	disabled,
	required,
	..._props
}: Props) => {
	const props = cleanBoxProps(_props);
	const [checkedValues, setValues] = useState(value ?? []);
	useDidUpdateEffect(() => {
		setValues(value ?? []);
	}, [value]);

	const _onChange = useCallback(
		(val: string) => {
			const newValues = _xor(checkedValues, [val]);
			setValues(newValues);
			onChange?.(newValues);
		},
		[onChange, checkedValues],
	);

	return (
		<FormRow
			className={classNames(
				'form__checkbox-list',
				error && 'form__checkbox-list--error',
				disabled && 'form__checkbox-list--disabled',
				className,
			)}
			label={label}
			error={error}
			error_label={error_label}
			help_label={help_label}
			required={required}
			required_label={required_label}
			{...props}
		>
			{options.map(({ value, label }, index) => (
				<Checkbox
					key={index}
					checked={checkedValues.includes(value)}
					label={label}
					onChange={() => _onChange(value)}
					disabled={disabled}
				/>
			))}
		</FormRow>
	);
};
